import { createWorkerAction } from '../../lib';

export const setWidgetHeight = createWorkerAction('SET_WIDGET_HEIGHT');
